import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, Eye } from "lucide-react";
import {
  dateFormat,
  formatMonthYear,
  getStatusColorClass,
} from "../../../utils/global";
import { AnimatePresence, motion } from "framer-motion";
import { AvatarGroup } from "../../../components/badge/AvatarGroup";
import axios from "../../../config/axios";
import ProjectDrawer from "../../../components/drawer/customer/ProjectDrawer";

export function AttendanceAppr() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/employes/emargements/projets");
        setProjects(response.data.projects.project_items || []);
      } catch (error) {
        console.error(error);
        setProjects([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const allProjects = projects?.length > 0 ? projects : [];

  const groupedProjects = allProjects.reduce((acc, projet) => {
    const monthKey = new Date(projet.start_date).toISOString().slice(0, 7);
    if (!acc[monthKey]) {
      acc[monthKey] = [];
    }
    acc[monthKey].push(projet);
    return acc;
  }, {});

  const sortedGroups = Object.entries(groupedProjects).sort((a, b) =>
    b[0].localeCompare(a[0]),
  );

  const [showDrawer, setShowDrawer] = useState(false);
  const [dataEtp, setDataEtp] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDataEtp = async (idEtp) => {
    setShowDrawer(true);
    setIsLoading(true);
    try {
      const res = await axios.get(`/cfp/etp-drawer/${idEtp}`);
      setDataEtp(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col w-full min-h-screen">
      <div>
        {loading ? (
          <div className="flex justify-center items-center h-[50vh]">
            <h1 className="text-gray-400">Chargement...</h1>
          </div>
        ) : sortedGroups?.length === 0 ? (
          <div className="flex justify-center items-center h-[50vh]">
            <h1>Aucun projet trouvé</h1>
          </div>
        ) : (
          <div>
            <AnimatePresence>
              {sortedGroups.map(([monthKey, projects], groupIndex) => (
                <div key={groupIndex}>
                  <div className="bg-gradient-to-r from-slate-50 to-gray-50 px-6 py-4 border-b border-gray-100">
                    <div className="flex items-center gap-3">
                      <Calendar className="w-6 h-6 text-gray-600" />
                      <h2 className="text-xl font-bold text-gray-800 capitalize">
                        {formatMonthYear(monthKey)}
                      </h2>
                      <span className="bg-gray-200 text-gray-700 text-sm font-medium px-2 py-1 rounded-full">
                        {projects.length} formation
                        {projects.length > 1 ? "s" : ""}
                      </span>
                    </div>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="w-full text-sm bg-white">
                      <thead className="bg-white border-b border-gray-100">
                        <tr className="text-left">
                          <th className="px-6 py-4 text-sm font-semibold text-gray-700 min-w-[250px]">
                            Formation
                          </th>
                          <th className="px-6 py-4 text-sm font-semibold text-gray-700 min-w-[180px]">
                            Période
                          </th>
                          <th className="px-6 py-4 text-sm font-semibold text-gray-700 min-w-[180px]">
                            Status
                          </th>
                          <th className="px-6 py-4 text-sm font-semibold text-gray-700">
                            Entreprise
                          </th>

                          <th className="px-6 py-4 text-sm font-semibold text-gray-700">
                            Formateurs
                          </th>

                          <th className="px-6 py-4 text-sm font-semibold text-gray-700">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {console.log(projects)}
                        {projects.map((projet, index) => (
                          <motion.tr
                            key={projet.id || index}
                            className="border-b border-gray-50 hover:bg-gray-50/50 transition-colors duration-200 "
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{
                              delay: groupIndex * 0.1 + index * 0.05,
                            }}
                          >
                            <td className="px-6 py-4">{projet.module_name}</td>
                            <td className="px-6 py-4">
                              <div className="text-sm">
                                <div className="font-medium text-gray-900">
                                  {dateFormat(projet.start_date)}
                                </div>
                                <div className="text-gray-500">
                                  {dateFormat(projet.end_date)}
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4">
                              <span
                                className={`p-1 rounded-full text-white  ${getStatusColorClass(
                                  projet.project_status,
                                )}`}
                              >
                                {projet.project_status}
                              </span>
                            </td>

                            <td className="px-6 py-4">
                              {/* {projet.entreprises.map((etp) => (
                                <p
                                  key={etp.idEtp}
                                  onClick={() => fetchDataEtp(etp.idEtp)}
                                  className="cursor-pointer "
                                >
                                  {" "}
                                  {etp.etp_name}{" "}
                                </p>
                              ))} */}
                              {projet.etp_name}
                            </td>
                            <td className="px-6 py-4">
                              {projet.formateurs.length === 0 ? (
                                <div className="text-gray-400">
                                  Aucun formateur
                                </div>
                              ) : (
                                <AvatarGroup
                                  items={projet.formateurs}
                                  type="trainer"
                                />
                              )}
                            </td>
                            <td className="px-6 py-4">
                              <Eye
                                onClick={() =>
                                  navigate(
                                    `/particulier/presence/emargement/${projet.id}`,
                                  )
                                }
                                size={16}
                                className="text-gray-400 cursor-pointer"
                              />
                            </td>
                          </motion.tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </AnimatePresence>
          </div>
        )}
      </div>
      {showDrawer && (
        <ProjectDrawer
          account="cfp"
          data={dataEtp}
          onClose={() => setShowDrawer(false)}
          isShow={showDrawer}
          isLoading={isLoading}
        />
      )}
    </div>
  );
}
